var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-content" },
    [
      _c("div", { staticClass: "logo" }),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "close-button", on: { click: _vm.closePage } },
        [_vm._v("\n      Close\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-content" }, [
      _c("div", { staticClass: "content-title" }, [
        _vm._v("\n      CONTAINER TYPE DETAIL\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "conetn-info" }, [
        _vm._v("\n      SITC Container Type Detail\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "5px" } }, [
        _c(
          "table",
          {
            staticStyle: { "border-collapse": "collapse" },
            attrs: {
              align: "center",
              width: "100%",
              border: "1px solid rgb(204,204,204)",
              cellpadding: ".",
            },
          },
          [
            _c("tbody", [
              _c("tr", [
                _c(
                  "td",
                  {
                    staticClass: "item-center",
                    staticStyle: {
                      width: "30%",
                      "background-color": "rgba(209,232,255,1)",
                    },
                  },
                  [_vm._v("Equipment Code")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "item-center",
                    staticStyle: {
                      width: "70%",
                      "background-color": "rgba(221,221,221,1)",
                    },
                  },
                  [_vm._v("Container Desc")]
                ),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            20FR\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            20 FOOT FLATRACK\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            20GP\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            20 FOOT GENERAL PURPOSE\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            20HC\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            20 FOOT HIGH CUBE\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            20HR\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            20 FOOT HIGH CUBE REEFER\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            20OT\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            20 FOOT OPENTOP\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            20RF\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            20 FOOT REEFER\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            20TK\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            20 FOOT TANK\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40FH\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT HIGH FLATRACK\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40FR\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT FLATRACK\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40GP\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT GENERAL PURPOSE\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40HC\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT HIGH CUBE\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40HR\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT HIGH CUBE REEFER\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40OH\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT HIGH OPENTOP\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40OT\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT OPENTOP\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40RF\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT REEFER\n          "),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            40TK\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            40 FOOT TANK\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            45HC\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            45 FOOT HIGH CUBE\n          "),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-item1" }, [
                  _vm._v("\n            45HR\n          "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-item2" }, [
                  _vm._v("\n            45 FOOT HIGH CUBE REEFER\n          "),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }